var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgComputerDesktop = function SvgComputerDesktop(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 16.92L4.14 16.86C3.51 16.86 3 16.29 3 15.57L3.03 4.29C3.03 3.57 3.54 3 4.17 3L19.86 3.05999C20.49 3.05999 21 3.63 21 4.35L20.97 15.63C21 16.35 20.46 16.92 19.83 16.92Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18164 14.3396C5.62936 14.3364 5.18424 13.8861 5.18745 13.3338L5.22663 6.5838C5.22984 6.03152 5.68015 5.5864 6.23244 5.58961L17.8724 5.65718C18.4247 5.66039 18.8698 6.1107 18.8666 6.66299L18.8274 13.413C18.8242 13.9653 18.3739 14.4104 17.8216 14.4072L6.18164 14.3396ZM7.19325 12.3454L16.8332 12.4014L16.8608 7.65138L7.22083 7.59541L7.19325 12.3454Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5698 21H14.3698C14.2798 21 14.2198 20.94 14.2198 20.85V17.0699H9.83984V19.8599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83975 19.86V20.85C9.83975 20.94 9.77975 21 9.68975 21H8.48975",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82031 21H15.5103",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgComputerDesktop as ReactComponent };
export default __webpack_public_path__ + "static/media/computer-desktop.da0dc4bd.svg";